import React, { useEffect, useRef, useState } from 'react';
import "./faqs.scss";
import { Container, Row, Col, Accordion} from 'react-bootstrap';
import GlitchLines from '../../components/glitchLines/glitchLines';
import LetsTalk from '../../components/letsTalk/letsTalk';
import { FaSearch, FaSadTear } from 'react-icons/fa';
import { useAnimationContext } from '../../AnimationContext';
import gsap from 'gsap';
import useFetch from '../../useFetch';
import { Spinner } from 'react-bootstrap';

//ps: look into not using dangerouslySetInnerHTML 

const FAQs = () => {
    const { isPreloaderComplete } = useAnimationContext();

    //handles glithLines
    const parentRef = useRef(null);

    //handles search
    const [searchValue, setSearchValue] = useState('');

    //initialize accordion content
    const [accordionContent, setAccordionContent] = useState({ FAQ1: [], FAQ2: [] });
    const [originalContent, setOriginalContent] = useState({ FAQ1: [], FAQ2: [] });
    const [activeKeys, setActiveKeys] = useState({ FAQ1: [], FAQ2: ['0'] });

    //load google sheets data
    const sheetRange = "FAQs";
    const { data, loading, error } = useFetch(sheetRange);

    useEffect(() => {
        if (data) {
            const rows = data.values.slice(1);
            const content = { FAQ1: [], FAQ2: [] };

            rows.forEach(row => {
                const [category, header, body] = row;
                const item = { header, body };

                if (category === 'FAQ 1') {
                    content.FAQ1.push(item);
                } else if (category === 'FAQ 2') {
                    content.FAQ2.push(item);
                }
            });

            setAccordionContent(content);
            setOriginalContent(content);
        }
    }, [data]);
    
    const highlightWord = (text, keyword) => {
        const regex = new RegExp(`(${keyword})`, 'gi');
        return text.replace(regex, '<span class="highlightWord">$1</span>');
    };

    const resetContent = () => {
        setAccordionContent(originalContent);
        setActiveKeys({ FAQ1: [], FAQ2: [] });
    };

    const highlightContent = (keyword) => {
        const updatedContent = {
            FAQ1: originalContent.FAQ1.map(item => ({
                header: highlightWord(item.header, keyword),
                body: highlightWord(item.body, keyword)
            })),
            FAQ2: originalContent.FAQ2.map(item => ({
                header: highlightWord(item.header, keyword),
                body: highlightWord(item.body, keyword)
            }))
        };
        setAccordionContent(updatedContent);

        const matchingKeys = {
            FAQ1: originalContent.FAQ1
                .map((item, index) => (item.header.toLowerCase().includes(keyword) || item.body.toLowerCase().includes(keyword)) ? index.toString() : null)
                .filter(key => key !== null),
            FAQ2: originalContent.FAQ2
                .map((item, index) => (item.header.toLowerCase().includes(keyword) || item.body.toLowerCase().includes(keyword)) ? index.toString() : null)
                .filter(key => key !== null)
        };
        setActiveKeys(matchingKeys);
    };

    const handleSearchClick = () => {
        const keyword = searchValue.trim().toLowerCase();
        if (keyword) {
            highlightContent(keyword);
        } else {
            resetContent();
        }
    };

    const handleSelect = (faqKey, eventKey) => {
        setActiveKeys(prevKeys => ({
            ...prevKeys,
            [faqKey]: prevKeys[faqKey].includes(eventKey) ? prevKeys[faqKey].filter(key => key !== eventKey) : [...prevKeys[faqKey], eventKey]
        }));
    };

    useEffect(() => {
        if (!loading) {
            gsap.fromTo("#rowsFAQ", 
                { y: 200, opacity: 0 }, // from state
                {
                    duration: 1,
                    y: 0,
                    opacity: 1,
                    ease: 'none' 
                }
            );
        }
    }, [loading]);

    return (
    <div ref={parentRef}>
        <GlitchLines parentRef={parentRef} />
        <svg className="glitchLines">
            <defs>
                <filter id="noise">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="2" result="noise" seed="1" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="5" />
                </filter>
            </defs>
            <g className="d-none d-lg-block">
            <line x1="0" y1="10%" x2="100%" y2="30%" />
            <line x1="0" y1="90%" x2="53%" y2="0" />
            <line x1="3%" y1="0" x2="60%" y2="100%" />
            </g>
            <g className="d-lg-none">
            <line x1="25%" y1="0" x2="100%" y2="18%" />
            <line x1="0" y1="43%" x2="100%" y2="70%" />
            <line x1="0" y1="63%" x2="100%" y2="10%" />
            </g>
        </svg>
        <section id="secFAQ">
            <Container fluid>
                <Row>
                    <Col md={6} className="d-flex flex-column align-items-center align-items-md-start">
                        <h1 className={`headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>Did you ever</h1>
                        <h1 className={`headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>Wonder...</h1>
                    </Col>
                    <Col md={6} >
                        <div className="search-wrapper d-none d-md-block ">
                            <input className="search-input" type="search" id="searchBox"
                                value={searchValue} placeholder="Enter keywords to search"
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') { handleSearchClick(); } }} 
                            />
                            <FaSearch className="search-icon" onClick={handleSearchClick} />
                        </div>
                    </Col>
                </Row>
            </Container>
            {loading ? (
                <div className='d-flex align-items-center justify-content-center secLoad'>
                    <Spinner animation="grow" role="status" className='loadingSpinner'>
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : error ? ( 
                <div className='d-flex flex-column align-items-center justify-content-center secLoad'>
                    <FaSadTear size={60} />
                    <h2>Error loading data: {error.message}</h2>
                </div>  
            ) : (
            <Container fluid id='rowsFAQ'>
                <Row>
                    <Col md={6} className="d-md-flex justify-content-md-end topicSpacer">
                        <h3>What is Graphic design?</h3>
                    </Col>
                    <Col md={6}>
                        <Accordion id="accordionFAQ1" activeKey={activeKeys.FAQ1} onSelect={(eventKey) => handleSelect('FAQ1', eventKey)}>
                            {accordionContent.FAQ1.map((item, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header>
                                        <span dangerouslySetInnerHTML={{ __html: item.header }}></span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <span dangerouslySetInnerHTML={{ __html: item.body }}></span>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="d-md-flex justify-content-md-end topicSpacer">
                        <h3 className="d-md-none">what i do &amp; what i don’t?</h3>
                        <h3 className="text-end d-none d-md-block">what i do &amp;<br />what i don’t?</h3>
                    </Col>
                    <Col md={6}>
                        <Accordion id="accordionFAQ2" activeKey={activeKeys.FAQ2} onSelect={(eventKey) => handleSelect('FAQ2', eventKey)}>
                            {accordionContent.FAQ2.map((item, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header>
                                        <span dangerouslySetInnerHTML={{ __html: item.header }}></span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <span dangerouslySetInnerHTML={{ __html: item.body }}></span>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
            )}
            <LetsTalk />
        </section>
    </div>
    )
}

export default FAQs;

